export { default as ArrowDropDown } from './components/ArrowDropDown';
export { default as ArrowForward } from './components/ArrowForward';
export { default as ArrowRight } from './components/ArrowRight';
export { default as Close } from './components/Close';
export { default as ColorFill } from './components/ColorFill';
export { default as Contacts } from './components/Contacts';
export { default as Contrast } from './components/Contrast';
export { default as Copyright } from './components/Copyright';
export { default as Document } from './components/Document';
export { default as ExpandLess } from './components/ExpandLess';
export { default as External } from './components/External';
export { default as Info } from './components/Info';
export { default as Mail } from './components/Mail';
export { default as Menu } from './components/Menu';
export { default as News } from './components/News';
export { default as Search } from './components/Search';
export { default as SortAlpha } from './components/SortAlpha';
export { default as Video } from './components/Video';
export { default as VideoPlay } from './components/VideoPlay';
export { default as Waves } from './components/Waves';
export { default as Wind } from './components/Wind';
export { default as Download } from './components/Download';

// Social
export { default as Draugiem } from './components/social/Draugiem';
export { default as Facebook } from './components/social/Facebook';
export { default as Instagram } from './components/social/Instagram';
export { default as Twitter } from './components/social/Twitter';
export { default as Youtube } from './components/social/Youtube';

// Files
export { default as AVI } from './components/files/AVI';
export { default as DOC } from './components/files/DOC';
export { default as JPG } from './components/files/JPG';
export { default as MOV } from './components/files/MOV';
export { default as PDF } from './components/files/PDF';
export { default as PPT } from './components/files/PPT';
export { default as TXT } from './components/files/TXT';
export { default as XLM } from './components/files/XLM';
export { default as XLS } from './components/files/XLS';
export { default as XLTM } from './components/files/XLTM';

// File types
export { default as AudioFile } from './components/files/types/Audio';
export { default as ExcelFile } from './components/files/types/Excel';
export { default as ImageFile } from './components/files/types/Image';
export { default as PresentationFile } from './components/files/types/Presentation';
export { default as TextFile } from './components/files/types/Text';
export { default as VideoFile } from './components/files/types/Video';

export { default as Loading } from './components/Loading';



// WEBPACK FOOTER //
// ./src/core/icons/index.js